// src/contexts/AuthContext.tsx

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
// Yahaan hum apne customized service se zaroori cheezein import kar rahe hain
import { fetchProfileData,} from '../services/profileService'; 

interface User {
  id: string;
  name: string;
  email: string;
  // Yeh flag hum login ke time set karenge
  isProfileComplete?: boolean;
}

interface AuthContextType {
  isAuthenticated: boolean;
  user: User | null;
  // Aapke service ke hisaab se, token `Basic ...` format mein ho sakta hai,
  // lekin hum yahaan sirf raw credentials store karenge
  token: string | null; 
  login: (token: string, userData: User) => Promise<void>;
  logout: () => void;
  isLoading: boolean;
  updateProfileCompletion: (isComplete: boolean) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  // Token ko state mein manage karna zaroori hai
  const [token, setToken] = useState<string | null>(localStorage.getItem('authCredentials'));

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setIsLoading(false);
  }, [token]);

  const login = async (newToken: string, userData: User): Promise<void> => {
    localStorage.setItem('authCredentials', newToken);
    localStorage.setItem('authToken', newToken);
    setToken(newToken);

    let isProfileComplete = false;
    try {
      
      await fetchProfileData();
     
      isProfileComplete = true;
    } catch (error) {
     
    }
    
    const finalUserData = { ...userData, isProfileComplete };
    
    localStorage.setItem('userData', JSON.stringify(finalUserData));
    setUser(finalUserData);
  };

  const logout = () => {
    localStorage.removeItem('authCredentials');
    localStorage.removeItem('userData');
    setUser(null);
    setToken(null);
  };

  const updateProfileCompletion = (isComplete: boolean) => {
    setUser(currentUser => {
      if (currentUser) {
        const updatedUser = { ...currentUser, isProfileComplete: isComplete };
        localStorage.setItem('userData', JSON.stringify(updatedUser));
        return updatedUser;
      }
      return null;
    });
  };
  
  const isAuthenticated = !!token;

  const contextValue = { 
    isAuthenticated, 
    user, 
    token, 
    login, 
    logout, 
    isLoading, 
    updateProfileCompletion 
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};